<template>
  <div class="alpha-water">
    <div class="alpha-water-mark" v-for="i in num" :key="i">{{ account }}</div>
  </div>
</template>
<script>
export default {
  props: {
    num: { type: Number, default: 6 },
  },
  computed: {
    account() {
      return app.user.account || ''
    },
  },
}
</script>
